import React, { Component } from "react";
import PropTypes from "prop-types";
import { MapView, BookableErrorMessageNoIntl } from "~/components";
import { getStatusDetails } from "../../../../utils/misc";
import { injectIntl, defineMessages } from "react-intl";
import constants from "../../../../utils/constants";
import getSymbolFromCurrency from "currency-symbol-map";
import classnames from "classnames";
import styles from "./PropertyMapView.scss";

const msgs = defineMessages({
  perNight: {
    id: "room_selection.entity_type.night",
    description: "Price per night text",
    defaultMessage: "per night",
  },
});

class PropertyMapView extends Component {
  constructor(props) {
    super(props);
    this.createMarkers = this.createMarkers.bind(this);
    const propertyMarkers = this.createMarkers(this.props);
    this.state = {
      propertyMarkers,
      center: this.getMapViewCenter(this.props.propertyList.toArray()),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.propertyList !== this.props.propertyList) {
      this.setState({ propertyMarkers: this.createMarkers(this.props) });
    }
  }

  getMapViewCenter(propertyMarkers) {
    if (propertyMarkers !== null && propertyMarkers.length > 0) {
      return {
        lat: propertyMarkers[0].get("contact").get("latitude"),
        lng: propertyMarkers[0].get("contact").get("longitude"),
      };
    }
    return {
      lat: -25.363882,
      lng: 131.044922,
    };
  }

  createMarkers(props) {
    const { propertyList, numberOfNights, currency } = props;
    return this.buildPropertyMarkers({
      propertyList: propertyList.toArray(),
      numberOfNights,
      currency,
    });
  }

  buildPropertyMarkers({ propertyList, numberOfNights, currency }) {
    const {
      intl: { formatMessage, formatDate, formatNumber },
    } = this.props;
    if (propertyList !== null && propertyList.length > 0) {
      return propertyList.map(property => {
        const statusCode =
          property && property.get("lastStatus") && property.get("lastStatus").get("code");
        const statusFilterType =
          property && property.get("lastStatus") && property.get("lastStatus").get("filterType");
        const statusValue =
          property && property.get("lastStatus") && property.get("lastStatus").get("value");
        // TODO: format always will be defined
        let rateMsg = (
          <BookableErrorMessageNoIntl
            {...getStatusDetails(statusCode, statusFilterType, statusValue, styles.statusLabel)}
            formatDate={formatDate}
            formatMessage={formatMessage}
          />
        );
        let priceRate = "X";
        if (statusCode === constants.PROPERTY_STATUS.AVAILABLE) {
          const pricePerNight = property.get("totalRate") / numberOfNights;
          const infoWindowRate =
            pricePerNight &&
            typeof pricePerNight === "number" &&
            formatNumber(pricePerNight, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          priceRate =
            pricePerNight && getSymbolFromCurrency(currency) + " " + Math.floor(pricePerNight);
          rateMsg = infoWindowRate + " " + currency + " " + formatMessage(msgs.perNight);
        }
        return {
          showInfo: false,
          title: property.get("name"),
          rate: priceRate,
          ticker: property.get("ticker"),
          lastStatus:
            (property.get("lastStatus") && property.get("lastStatus").get("code")) || null,
          content: (
            <div>
              <div className="textLeft">{property.get("contact").get("address")} </div>
              <div className="textLeft">{property.get("contact").get("city")} </div>
              <div
                className={classnames(
                  "textRight",
                  "rateMsg",
                  statusCode === constants.PROPERTY_STATUS.AVAILABLE && styles.availableColor,
                  statusCode === constants.PROPERTY_STATUS.RESTRICTED && styles.restrictedColor,
                  statusCode === constants.PROPERTY_STATUS.UNAVAILABLE && styles.unavailableColor
                )}>
                <b>{rateMsg}</b>
              </div>
            </div>
          ),
          directionLink: `https://www.google.com/maps/place/${property.get("name")}/@${property
            .get("contact")
            .get("latitude")},${property.get("contact").get("longitude")}`,
          position: new window.google.maps.LatLng(
            property.get("contact").get("latitude"),
            property.get("contact").get("longitude")
          ),
        };
      });
    }
  }

  render() {
    if (!this.state.propertyMarkers) {
      return null;
    }
    return (
      <MapView
        initialMarkers={this.state.propertyMarkers}
        initialCenter={this.state.center}
        onPropertySelect={this.props.handlePropertySelectInMap}
        hotelSelected={this.props.hotelSelected}
        onHover={this.props.handleMarkerOnHover}
        onMouseLeave={this.props.handleMarkerOnMouseLeave}
        hasPremiumMap={this.props.hasPremiumMap}
      />
    );
  }
}

//TODO: Correct proptypes
// PropertyMapView.propTypes = {
//   handlePropertySelectInMap: PropTypes.func.isRequired,
//   hotelSelected: PropTypes.string.isRequired,
//   handleMarkerOnHover: PropTypes.func.isRequired,
//   handleMarkerOnMouseLeave: PropTypes.func.isRequired,
//   intl: PropTypes.object.isRequired,
//   propertyList: PropTypes.object.isRequired,
//   numberOfNights: PropTypes.number.isRequired,
//   hasPremiumMap: PropTypes.bool.isRequired,
//   currency: PropTypes.string.isRequired
// };

export default injectIntl(PropertyMapView);
